var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ff-drop-down-component"},[_c('table-obj',{class:{'ff-drop-down--table' : _vm.hasClass},attrs:{"search":_vm.item,"search-component":true,"chinese-dictionary":_vm.ChineseDictionary},on:{"changeQuery":_vm.changeQuery}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }